import { useMemo } from 'react';
import times from 'lodash/times';
import { addDays, subDays } from 'date-fns';
import { DATE_FORMAT_DASH } from '../../../../../common/constants';
import type { DatePickerProps } from '../../../../../common/types';
import { formatDate } from '../../../../../common/utils/dates';

const VISIBLE_DAYS_IN_CALENDAR_MONTH = 42;

export const useDisabledDates = ({
	disabledDates = [],
	disablePast = false,
	disableFuture = false,
	minDate = new Date(),
	maxDate = new Date(),
}: DatePickerProps): string[] => {
	const futureDates = times(VISIBLE_DAYS_IN_CALENDAR_MONTH, (i) => addDays(new Date(), i + 1));

	const pastDates = times(VISIBLE_DAYS_IN_CALENDAR_MONTH, (i) => subDays(new Date(), i + 1));

	const minDates = times(VISIBLE_DAYS_IN_CALENDAR_MONTH, (i) => subDays(minDate, i + 1));

	const maxDates = times(VISIBLE_DAYS_IN_CALENDAR_MONTH, (i) => addDays(maxDate, i + 1));

	const disabled = useMemo(
		() =>
			[
				...disabledDates,
				...(disablePast ? pastDates : []),
				...(disableFuture ? futureDates : []),
				...(minDate !== undefined ? minDates : []),
				...(maxDate !== undefined ? maxDates : []),
			].map((date) => formatDate(date, DATE_FORMAT_DASH)),
		[
			disableFuture,
			disablePast,
			disabledDates,
			futureDates,
			maxDate,
			maxDates,
			minDate,
			minDates,
			pastDates,
		],
	);

	return disabled;
};
